export default __webpack_public_path__ + "static/gakurui-cho-award-7d3c024db2b5abb02f38f956903dab28.pdf";